<template>
  <div class="feature-item">
    <div class="feature-title">
      <slot name="title"></slot>
    </div>
    <div class="feature-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardFeature",
};
</script>

<style scoped>
.feature-item {
  background: white;
  border-radius: 10px;
  padding: 18px;
  border: 1px solid rgba(154, 27, 30, 0.08);
  transition: all 0.3s;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.02);
}
.feature-item:hover {
  background: rgba(154, 27, 30, 0.03);
  border-color: rgba(154, 27, 30, 0.2);
  transform: translateY(-3px);
  box-shadow: 0 6px 15px rgba(154, 27, 30, 0.08);
}
.feature-title {
  padding: 10px 20px;
  background: linear-gradient(135deg, #9a1b1e, #b2222244);
  border-radius: 10px;
  color: #fff;
}
.feature-content {
  margin-top: 20px;
}
</style>
